import { createSelector } from "reselect";

import { getTripLegHasUnreliableDuration } from "@app/helpers/udm/get-leg-has-unreliable-duration";

import { getSearchedLegSegments } from "./get-segments";

export const getSearchedLegHasUnreliableDuration = createSelector(
  [getSearchedLegSegments],
  trip_segments => {
    return getTripLegHasUnreliableDuration(trip_segments);
  }
);
